const ListIcon = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 5.75C22 5.33579 21.6642 5 21.25 5H5.75C5.3358 5 5 5.33579 5 5.75C5 6.16421 5.3358 6.5 5.75 6.5H21.25C21.6642 6.5 22 6.16421 22 5.75ZM22 17.75C22 17.3358 21.6642 17 21.25 17H8.75C8.3358 17 8 17.3358 8 17.75C8 18.1642 8.3358 18.5 8.75 18.5H21.25C21.6642 18.5 22 18.1642 22 17.75ZM21.25 11C21.6642 11 22 11.3358 22 11.75C22 12.1642 21.6642 12.5 21.25 12.5H2.75C2.3358 12.5 2 12.1642 2 11.75C2 11.3358 2.3358 11 2.75 11H21.25Z" fill="#212121" />
        </svg>
    );
}

export default ListIcon;